import { useBrowseMoreFilters } from '@aibees/elephant/feature/more-filters/hooks/use-browse-more-filters';

import { LoadingScreen, useIsMiniLayout } from '@aibees/shared/components';
import { useBoolean } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { Box, Button, useTheme } from '@mui/material';
import { Suspense, lazy, memo } from 'react';
import * as SX from './sx';
import type { MoreFiltersProps as Props } from './types';

const MoreFiltersFeature = lazy(() =>
  import('@aibees/elephant/feature/more-filters').then((module) => ({
    default: module.MoreFilters,
  }))
);

export const MoreFilters = memo(({ className }: Props) => {
  const dialogState = useBoolean();
  const api = useBrowseMoreFilters();
  const theme = useTheme();
  const isMini = useIsMiniLayout();

  const handleToggle = () => {
    dialogState.onToggle();
  };

  return (
    <Box
      className={classnames('MoreFilters', className)}
      height={theme.spacing(5.75)}
      sx={SX.root}
    >
      <Suspense fallback={<LoadingScreen position="relative" size={20} />}>
        <MoreFiltersFeature openingState={dialogState} pinningMode />
        <Button
          color="primary"
          size="large"
          onClick={handleToggle}
          disabled={!api.isSuccess}
          disableRipple
          variant="soft"
          square
          fullWidth
        >
          {isMini ? 'More' : 'More Filters'}
        </Button>
      </Suspense>
    </Box>
  );
});

MoreFilters.displayName = 'MoreFilters';
